(function () {
//import * as bootstrap from 'bootstrap'
//import Alert from '../../../node_modules/bootstrap/js/src/alert'
//import Button from '../../../node_modules/bootstrap/js/src/button'
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ const $10ded7cf756b400f$var$elementMap = new Map();
var $10ded7cf756b400f$export$2e2bcd8739ae039 = {
    set (element, key, instance) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) $10ded7cf756b400f$var$elementMap.set(element, new Map());
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error(`Bootstrap doesn't allow more than one instance per element. Bound instance: ${Array.from(instanceMap.keys())[0]}.`);
            return;
        }
        instanceMap.set(key, instance);
    },
    get (element, key) {
        if ($10ded7cf756b400f$var$elementMap.has(element)) return $10ded7cf756b400f$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove (element, key) {
        if (!$10ded7cf756b400f$var$elementMap.has(element)) return;
        const instanceMap = $10ded7cf756b400f$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $10ded7cf756b400f$var$elementMap.delete(element);
    }
};


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ const $624ac0747f128bc7$var$MAX_UID = 1000000;
const $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER = 1000;
const $624ac0747f128bc7$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ const $624ac0747f128bc7$export$529769e360e2fa1b = (selector)=>{
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, (match, id)=>`#${CSS.escape(id)}`);
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
const $624ac0747f128bc7$export$2fe53163c7bc4eaf = (object)=>{
    if (object === null || object === undefined) return `${object}`;
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ const $624ac0747f128bc7$export$6d2b3473b0986646 = (prefix)=>{
    do prefix += Math.floor(Math.random() * $624ac0747f128bc7$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
const $624ac0747f128bc7$export$530d045e570efb0f = (element)=>{
    if (!element) return 0;
    // Get transition-duration of the element
    let { transitionDuration: transitionDuration, transitionDelay: transitionDelay } = window.getComputedStyle(element);
    const floatTransitionDuration = Number.parseFloat(transitionDuration);
    const floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $624ac0747f128bc7$var$MILLISECONDS_MULTIPLIER;
};
const $624ac0747f128bc7$export$201d3c8336a47e6c = (element)=>{
    element.dispatchEvent(new Event($624ac0747f128bc7$var$TRANSITION_END));
};
const $624ac0747f128bc7$export$45a5e7f76e0caa8d = (object)=>{
    if (!object || typeof object !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
const $624ac0747f128bc7$export$d16800b7e59a8051 = (object)=>{
    // it's a jQuery object or a node element
    if ($624ac0747f128bc7$export$45a5e7f76e0caa8d(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($624ac0747f128bc7$export$529769e360e2fa1b(object));
    return null;
};
const $624ac0747f128bc7$export$795910f5f15a9633 = (element)=>{
    if (!$624ac0747f128bc7$export$45a5e7f76e0caa8d(element) || element.getClientRects().length === 0) return false;
    const elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    const closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        const summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
const $624ac0747f128bc7$export$30e0dc115df457ed = (element)=>{
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
const $624ac0747f128bc7$export$1a538cc28c24d2ec = (element)=>{
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $624ac0747f128bc7$export$1a538cc28c24d2ec(element.parentNode);
};
const $624ac0747f128bc7$export$8793edee2d425525 = ()=>{};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.harrytheo.com/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ const $624ac0747f128bc7$export$b7a864e1eaef9de5 = (element)=>{
    element.offsetHeight // eslint-disable-line no-unused-expressions
    ;
};
const $624ac0747f128bc7$export$74ab881f7fc208ab = ()=>{
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
const $624ac0747f128bc7$var$DOMContentLoadedCallbacks = [];
const $624ac0747f128bc7$export$62028ff70825ead9 = (callback)=>{
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$624ac0747f128bc7$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', ()=>{
            for (const callback of $624ac0747f128bc7$var$DOMContentLoadedCallbacks)callback();
        });
        $624ac0747f128bc7$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
const $624ac0747f128bc7$export$702d680b21cbd764 = ()=>document.documentElement.dir === 'rtl';
const $624ac0747f128bc7$export$6be86de4be20ff32 = (plugin)=>{
    $624ac0747f128bc7$export$62028ff70825ead9(()=>{
        const $ = $624ac0747f128bc7$export$74ab881f7fc208ab();
        /* istanbul ignore if */ if ($) {
            const name = plugin.NAME;
            const JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = ()=>{
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
const $624ac0747f128bc7$export$51396ec711da548b = (possibleCallback, args = [], defaultValue = possibleCallback)=>{
    return typeof possibleCallback === 'function' ? possibleCallback.call(...args) : defaultValue;
};
const $624ac0747f128bc7$export$d6cd5457cf4106ef = (callback, transitionElement, waitForTransition = true)=>{
    if (!waitForTransition) {
        $624ac0747f128bc7$export$51396ec711da548b(callback);
        return;
    }
    const durationPadding = 5;
    const emulatedDuration = $624ac0747f128bc7$export$530d045e570efb0f(transitionElement) + durationPadding;
    let called = false;
    const handler = ({ target: target })=>{
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
        $624ac0747f128bc7$export$51396ec711da548b(callback);
    };
    transitionElement.addEventListener($624ac0747f128bc7$var$TRANSITION_END, handler);
    setTimeout(()=>{
        if (!called) $624ac0747f128bc7$export$201d3c8336a47e6c(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ const $624ac0747f128bc7$export$7bc25e2173fc3d1f = (list, activeElement, shouldGetNext, isCycleAllowed)=>{
    const listLength = list.length;
    let index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};


/**
 * Constants
 */ const $1c297f733361d974$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
const $1c297f733361d974$var$stripNameRegex = /\..*/;
const $1c297f733361d974$var$stripUidRegex = /::\d+$/;
const $1c297f733361d974$var$eventRegistry = {} // Events storage
;
let $1c297f733361d974$var$uidEvent = 1;
const $1c297f733361d974$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
const $1c297f733361d974$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $1c297f733361d974$var$makeEventUid(element, uid) {
    return uid && `${uid}::${$1c297f733361d974$var$uidEvent++}` || element.uidEvent || $1c297f733361d974$var$uidEvent++;
}
function $1c297f733361d974$var$getElementEvents(element) {
    const uid = $1c297f733361d974$var$makeEventUid(element);
    element.uidEvent = uid;
    $1c297f733361d974$var$eventRegistry[uid] = $1c297f733361d974$var$eventRegistry[uid] || {};
    return $1c297f733361d974$var$eventRegistry[uid];
}
function $1c297f733361d974$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $1c297f733361d974$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $1c297f733361d974$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        const domElements = element.querySelectorAll(selector);
        for(let { target: target } = event; target && target !== this; target = target.parentNode)for (const domElement of domElements){
            if (domElement !== target) continue;
            $1c297f733361d974$var$hydrateObj(event, {
                delegateTarget: target
            });
            if (handler.oneOff) $1c297f733361d974$var$EventHandler.off(element, event.type, selector, fn);
            return fn.apply(target, [
                event
            ]);
        }
    };
}
function $1c297f733361d974$var$findHandler(events, callable, delegationSelector = null) {
    return Object.values(events).find((event)=>event.callable === callable && event.delegationSelector === delegationSelector);
}
function $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    const isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    const callable = isDelegated ? delegationFunction : handler || delegationFunction;
    let typeEvent = $1c297f733361d974$var$getTypeEvent(originalTypeEvent);
    if (!$1c297f733361d974$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $1c297f733361d974$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    let [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $1c297f733361d974$var$customEvents) {
        const wrapFunction = (fn)=>{
            return function(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    const events = $1c297f733361d974$var$getElementEvents(element);
    const handlers = events[typeEvent] || (events[typeEvent] = {});
    const previousFunction = $1c297f733361d974$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    const uid = $1c297f733361d974$var$makeEventUid(callable, originalTypeEvent.replace($1c297f733361d974$var$namespaceRegex, ''));
    const fn = isDelegated ? $1c297f733361d974$var$bootstrapDelegationHandler(element, handler, callable) : $1c297f733361d974$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $1c297f733361d974$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    const fn = $1c297f733361d974$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $1c297f733361d974$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    const storeElementEvent = events[typeEvent] || {};
    for (const [handlerKey, event] of Object.entries(storeElementEvent))if (handlerKey.includes(namespace)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
}
function $1c297f733361d974$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($1c297f733361d974$var$stripNameRegex, '');
    return $1c297f733361d974$var$customEvents[event] || event;
}
const $1c297f733361d974$var$EventHandler = {
    on (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one (element, event, handler, delegationFunction) {
        $1c297f733361d974$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off (element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        const [isDelegated, callable, typeEvent] = $1c297f733361d974$var$normalizeParameters(originalTypeEvent, handler, delegationFunction);
        const inNamespace = typeEvent !== originalTypeEvent;
        const events = $1c297f733361d974$var$getElementEvents(element);
        const storeElementEvent = events[typeEvent] || {};
        const isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $1c297f733361d974$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        if (isNamespace) for (const elementEvent of Object.keys(events))$1c297f733361d974$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
        for (const [keyHandlers, event] of Object.entries(storeElementEvent)){
            const handlerKey = keyHandlers.replace($1c297f733361d974$var$stripUidRegex, '');
            if (!inNamespace || originalTypeEvent.includes(handlerKey)) $1c297f733361d974$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    },
    trigger (element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        const $ = (0, $624ac0747f128bc7$export$74ab881f7fc208ab)();
        const typeEvent = $1c297f733361d974$var$getTypeEvent(event);
        const inNamespace = event !== typeEvent;
        let jQueryEvent = null;
        let bubbles = true;
        let nativeDispatch = true;
        let defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        const evt = $1c297f733361d974$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $1c297f733361d974$var$hydrateObj(obj, meta = {}) {
    for (const [key, value] of Object.entries(meta))try {
        obj[key] = value;
    } catch  {
        Object.defineProperty(obj, key, {
            configurable: true,
            get () {
                return value;
            }
        });
    }
    return obj;
}
var $1c297f733361d974$export$2e2bcd8739ae039 = $1c297f733361d974$var$EventHandler;


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $61e4c97070b47d88$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch  {
        return value;
    }
}
function $61e4c97070b47d88$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, (chr)=>`-${chr.toLowerCase()}`);
}
const $61e4c97070b47d88$var$Manipulator = {
    setDataAttribute (element, key, value) {
        element.setAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`, value);
    },
    removeDataAttribute (element, key) {
        element.removeAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`);
    },
    getDataAttributes (element) {
        if (!element) return {};
        const attributes = {};
        const bsKeys = Object.keys(element.dataset).filter((key)=>key.startsWith('bs') && !key.startsWith('bsConfig'));
        for (const key of bsKeys){
            let pureKey = key.replace(/^bs/, '');
            pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1);
            attributes[pureKey] = $61e4c97070b47d88$var$normalizeData(element.dataset[key]);
        }
        return attributes;
    },
    getDataAttribute (element, key) {
        return $61e4c97070b47d88$var$normalizeData(element.getAttribute(`data-bs-${$61e4c97070b47d88$var$normalizeDataKey(key)}`));
    }
};
var $61e4c97070b47d88$export$2e2bcd8739ae039 = $61e4c97070b47d88$var$Manipulator;



/**
 * Class definition
 */ class $7beb0d0c06e1a235$var$Config {
    // Getters
    static get Default() {
        return {};
    }
    static get DefaultType() {
        return {};
    }
    static get NAME() {
        throw new Error('You have to implement the static method "NAME", for each component!');
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    _configAfterMerge(config) {
        return config;
    }
    _mergeConfigObj(config, element) {
        const jsonConfig = (0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(element) ? (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(element, 'config') : {} // try to parse
        ;
        return {
            ...this.constructor.Default,
            ...typeof jsonConfig === 'object' ? jsonConfig : {},
            ...(0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(element) ? (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttributes(element) : {},
            ...typeof config === 'object' ? config : {}
        };
    }
    _typeCheckConfig(config, configTypes = this.constructor.DefaultType) {
        for (const [property, expectedTypes] of Object.entries(configTypes)){
            const value = config[property];
            const valueType = (0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(value) ? 'element' : (0, $624ac0747f128bc7$export$2fe53163c7bc4eaf)(value);
            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError(`${this.constructor.NAME.toUpperCase()}: Option "${property}" provided type "${valueType}" but expected type "${expectedTypes}".`);
        }
    }
}
var $7beb0d0c06e1a235$export$2e2bcd8739ae039 = $7beb0d0c06e1a235$var$Config;



/**
 * Constants
 */ const $380170e9fa23ab96$var$VERSION = '5.3.8';
/**
 * Class definition
 */ class $380170e9fa23ab96$var$BaseComponent extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(element, config){
        super();
        element = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(element);
        if (!element) return;
        this._element = element;
        this._config = this._getConfig(config);
        (0, $10ded7cf756b400f$export$2e2bcd8739ae039).set(this._element, this.constructor.DATA_KEY, this);
    }
    // Public
    dispose() {
        (0, $10ded7cf756b400f$export$2e2bcd8739ae039).remove(this._element, this.constructor.DATA_KEY);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, this.constructor.EVENT_KEY);
        for (const propertyName of Object.getOwnPropertyNames(this))this[propertyName] = null;
    }
    // Private
    _queueCallback(callback, element, isAnimated = true) {
        (0, $624ac0747f128bc7$export$d6cd5457cf4106ef)(callback, element, isAnimated);
    }
    _getConfig(config) {
        config = this._mergeConfigObj(config, this._element);
        config = this._configAfterMerge(config);
        this._typeCheckConfig(config);
        return config;
    }
    // Static
    static getInstance(element) {
        return (0, $10ded7cf756b400f$export$2e2bcd8739ae039).get((0, $624ac0747f128bc7$export$d16800b7e59a8051)(element), this.DATA_KEY);
    }
    static getOrCreateInstance(element, config = {}) {
        return this.getInstance(element) || new this(element, typeof config === 'object' ? config : null);
    }
    static get VERSION() {
        return $380170e9fa23ab96$var$VERSION;
    }
    static get DATA_KEY() {
        return `bs.${this.NAME}`;
    }
    static get EVENT_KEY() {
        return `.${this.DATA_KEY}`;
    }
    static eventName(name) {
        return `${name}${this.EVENT_KEY}`;
    }
}
var $380170e9fa23ab96$export$2e2bcd8739ae039 = $380170e9fa23ab96$var$BaseComponent;




/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 
const $56a58c95834dffd7$var$getSelector = (element)=>{
    let selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        let hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = `#${hrefAttribute.split('#')[1]}`;
        selector = hrefAttribute && hrefAttribute !== '#' ? hrefAttribute.trim() : null;
    }
    return selector ? selector.split(',').map((sel)=>(0, $624ac0747f128bc7$export$529769e360e2fa1b)(sel)).join(',') : null;
};
const $56a58c95834dffd7$var$SelectorEngine = {
    find (selector, element = document.documentElement) {
        return [].concat(...Element.prototype.querySelectorAll.call(element, selector));
    },
    findOne (selector, element = document.documentElement) {
        return Element.prototype.querySelector.call(element, selector);
    },
    children (element, selector) {
        return [].concat(...element.children).filter((child)=>child.matches(selector));
    },
    parents (element, selector) {
        const parents = [];
        let ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev (element, selector) {
        let previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next (element, selector) {
        let next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren (element) {
        const focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map((selector)=>`${selector}:not([tabindex^="-"])`).join(',');
        return this.find(focusables, element).filter((el)=>!(0, $624ac0747f128bc7$export$30e0dc115df457ed)(el) && (0, $624ac0747f128bc7$export$795910f5f15a9633)(el));
    },
    getSelectorFromElement (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        if (selector) return $56a58c95834dffd7$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector (element) {
        const selector = $56a58c95834dffd7$var$getSelector(element);
        return selector ? $56a58c95834dffd7$var$SelectorEngine.find(selector) : [];
    }
};
var $56a58c95834dffd7$export$2e2bcd8739ae039 = $56a58c95834dffd7$var$SelectorEngine;



/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $0bc25ea29b774e6d$var$NAME = 'swipe';
const $0bc25ea29b774e6d$var$EVENT_KEY = '.bs.swipe';
const $0bc25ea29b774e6d$var$EVENT_TOUCHSTART = `touchstart${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_TOUCHMOVE = `touchmove${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_TOUCHEND = `touchend${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_POINTERDOWN = `pointerdown${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$EVENT_POINTERUP = `pointerup${$0bc25ea29b774e6d$var$EVENT_KEY}`;
const $0bc25ea29b774e6d$var$POINTER_TYPE_TOUCH = 'touch';
const $0bc25ea29b774e6d$var$POINTER_TYPE_PEN = 'pen';
const $0bc25ea29b774e6d$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
const $0bc25ea29b774e6d$var$SWIPE_THRESHOLD = 40;
const $0bc25ea29b774e6d$var$Default = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
const $0bc25ea29b774e6d$var$DefaultType = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ class $0bc25ea29b774e6d$var$Swipe extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(element, config){
        super();
        this._element = element;
        if (!element || !$0bc25ea29b774e6d$var$Swipe.isSupported()) return;
        this._config = this._getConfig(config);
        this._deltaX = 0;
        this._supportPointerEvents = Boolean(window.PointerEvent);
        this._initEvents();
    }
    // Getters
    static get Default() {
        return $0bc25ea29b774e6d$var$Default;
    }
    static get DefaultType() {
        return $0bc25ea29b774e6d$var$DefaultType;
    }
    static get NAME() {
        return $0bc25ea29b774e6d$var$NAME;
    }
    // Public
    dispose() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, $0bc25ea29b774e6d$var$EVENT_KEY);
    }
    // Private
    _start(event) {
        if (!this._supportPointerEvents) {
            this._deltaX = event.touches[0].clientX;
            return;
        }
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
    }
    _end(event) {
        if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
        this._handleSwipe();
        (0, $624ac0747f128bc7$export$51396ec711da548b)(this._config.endCallback);
    }
    _move(event) {
        this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
    }
    _handleSwipe() {
        const absDeltaX = Math.abs(this._deltaX);
        if (absDeltaX <= $0bc25ea29b774e6d$var$SWIPE_THRESHOLD) return;
        const direction = absDeltaX / this._deltaX;
        this._deltaX = 0;
        if (!direction) return;
        (0, $624ac0747f128bc7$export$51396ec711da548b)(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
    }
    _initEvents() {
        if (this._supportPointerEvents) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_POINTERDOWN, (event)=>this._start(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_POINTERUP, (event)=>this._end(event));
            this._element.classList.add($0bc25ea29b774e6d$var$CLASS_NAME_POINTER_EVENT);
        } else {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHSTART, (event)=>this._start(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHMOVE, (event)=>this._move(event));
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $0bc25ea29b774e6d$var$EVENT_TOUCHEND, (event)=>this._end(event));
        }
    }
    _eventIsPointerPenTouch(event) {
        return this._supportPointerEvents && (event.pointerType === $0bc25ea29b774e6d$var$POINTER_TYPE_PEN || event.pointerType === $0bc25ea29b774e6d$var$POINTER_TYPE_TOUCH);
    }
    // Static
    static isSupported() {
        return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
    }
}
var $0bc25ea29b774e6d$export$2e2bcd8739ae039 = $0bc25ea29b774e6d$var$Swipe;


/**
 * Constants
 */ const $dbacec9b9313e733$var$NAME = 'carousel';
const $dbacec9b9313e733$var$DATA_KEY = 'bs.carousel';
const $dbacec9b9313e733$var$EVENT_KEY = `.${$dbacec9b9313e733$var$DATA_KEY}`;
const $dbacec9b9313e733$var$DATA_API_KEY = '.data-api';
const $dbacec9b9313e733$var$ARROW_LEFT_KEY = 'ArrowLeft';
const $dbacec9b9313e733$var$ARROW_RIGHT_KEY = 'ArrowRight';
const $dbacec9b9313e733$var$TOUCHEVENT_COMPAT_WAIT = 500 // Time for mouse compat events to fire after touch
;
const $dbacec9b9313e733$var$ORDER_NEXT = 'next';
const $dbacec9b9313e733$var$ORDER_PREV = 'prev';
const $dbacec9b9313e733$var$DIRECTION_LEFT = 'left';
const $dbacec9b9313e733$var$DIRECTION_RIGHT = 'right';
const $dbacec9b9313e733$var$EVENT_SLIDE = `slide${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_SLID = `slid${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_KEYDOWN = `keydown${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_MOUSEENTER = `mouseenter${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_MOUSELEAVE = `mouseleave${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_DRAG_START = `dragstart${$dbacec9b9313e733$var$EVENT_KEY}`;
const $dbacec9b9313e733$var$EVENT_LOAD_DATA_API = `load${$dbacec9b9313e733$var$EVENT_KEY}${$dbacec9b9313e733$var$DATA_API_KEY}`;
const $dbacec9b9313e733$var$EVENT_CLICK_DATA_API = `click${$dbacec9b9313e733$var$EVENT_KEY}${$dbacec9b9313e733$var$DATA_API_KEY}`;
const $dbacec9b9313e733$var$CLASS_NAME_CAROUSEL = 'carousel';
const $dbacec9b9313e733$var$CLASS_NAME_ACTIVE = 'active';
const $dbacec9b9313e733$var$CLASS_NAME_SLIDE = 'slide';
const $dbacec9b9313e733$var$CLASS_NAME_END = 'carousel-item-end';
const $dbacec9b9313e733$var$CLASS_NAME_START = 'carousel-item-start';
const $dbacec9b9313e733$var$CLASS_NAME_NEXT = 'carousel-item-next';
const $dbacec9b9313e733$var$CLASS_NAME_PREV = 'carousel-item-prev';
const $dbacec9b9313e733$var$SELECTOR_ACTIVE = '.active';
const $dbacec9b9313e733$var$SELECTOR_ITEM = '.carousel-item';
const $dbacec9b9313e733$var$SELECTOR_ACTIVE_ITEM = $dbacec9b9313e733$var$SELECTOR_ACTIVE + $dbacec9b9313e733$var$SELECTOR_ITEM;
const $dbacec9b9313e733$var$SELECTOR_ITEM_IMG = '.carousel-item img';
const $dbacec9b9313e733$var$SELECTOR_INDICATORS = '.carousel-indicators';
const $dbacec9b9313e733$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
const $dbacec9b9313e733$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
const $dbacec9b9313e733$var$KEY_TO_DIRECTION = {
    [$dbacec9b9313e733$var$ARROW_LEFT_KEY]: $dbacec9b9313e733$var$DIRECTION_RIGHT,
    [$dbacec9b9313e733$var$ARROW_RIGHT_KEY]: $dbacec9b9313e733$var$DIRECTION_LEFT
};
const $dbacec9b9313e733$var$Default = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
const $dbacec9b9313e733$var$DefaultType = {
    interval: '(number|boolean)',
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ class $dbacec9b9313e733$var$Carousel extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._interval = null;
        this._activeElement = null;
        this._isSliding = false;
        this.touchTimeout = null;
        this._swipeHelper = null;
        this._indicatorsElement = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_INDICATORS, this._element);
        this._addEventListeners();
        if (this._config.ride === $dbacec9b9313e733$var$CLASS_NAME_CAROUSEL) this.cycle();
    }
    // Getters
    static get Default() {
        return $dbacec9b9313e733$var$Default;
    }
    static get DefaultType() {
        return $dbacec9b9313e733$var$DefaultType;
    }
    static get NAME() {
        return $dbacec9b9313e733$var$NAME;
    }
    // Public
    next() {
        this._slide($dbacec9b9313e733$var$ORDER_NEXT);
    }
    nextWhenVisible() {
        // FIXME TODO use `document.visibilityState`
        // Don't call next when the page isn't visible
        // or the carousel or its parent isn't visible
        if (!document.hidden && (0, $624ac0747f128bc7$export$795910f5f15a9633)(this._element)) this.next();
    }
    prev() {
        this._slide($dbacec9b9313e733$var$ORDER_PREV);
    }
    pause() {
        if (this._isSliding) (0, $624ac0747f128bc7$export$201d3c8336a47e6c)(this._element);
        this._clearInterval();
    }
    cycle() {
        this._clearInterval();
        this._updateInterval();
        this._interval = setInterval(()=>this.nextWhenVisible(), this._config.interval);
    }
    _maybeEnableCycle() {
        if (!this._config.ride) return;
        if (this._isSliding) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $dbacec9b9313e733$var$EVENT_SLID, ()=>this.cycle());
            return;
        }
        this.cycle();
    }
    to(index) {
        const items = this._getItems();
        if (index > items.length - 1 || index < 0) return;
        if (this._isSliding) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $dbacec9b9313e733$var$EVENT_SLID, ()=>this.to(index));
            return;
        }
        const activeIndex = this._getItemIndex(this._getActive());
        if (activeIndex === index) return;
        const order = index > activeIndex ? $dbacec9b9313e733$var$ORDER_NEXT : $dbacec9b9313e733$var$ORDER_PREV;
        this._slide(order, items[index]);
    }
    dispose() {
        if (this._swipeHelper) this._swipeHelper.dispose();
        super.dispose();
    }
    // Private
    _configAfterMerge(config) {
        config.defaultInterval = config.interval;
        return config;
    }
    _addEventListeners() {
        if (this._config.keyboard) (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_KEYDOWN, (event)=>this._keydown(event));
        if (this._config.pause === 'hover') {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_MOUSEENTER, ()=>this.pause());
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $dbacec9b9313e733$var$EVENT_MOUSELEAVE, ()=>this._maybeEnableCycle());
        }
        if (this._config.touch && (0, $0bc25ea29b774e6d$export$2e2bcd8739ae039).isSupported()) this._addTouchEventListeners();
    }
    _addTouchEventListeners() {
        for (const img of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_ITEM_IMG, this._element))(0, $1c297f733361d974$export$2e2bcd8739ae039).on(img, $dbacec9b9313e733$var$EVENT_DRAG_START, (event)=>event.preventDefault());
        const endCallBack = ()=>{
            if (this._config.pause !== 'hover') return;
            // If it's a touch-enabled device, mouseenter/leave are fired as
            // part of the mouse compatibility events on first tap - the carousel
            // would stop cycling until user tapped out of it;
            // here, we listen for touchend, explicitly pause the carousel
            // (as if it's the second time we tap on it, mouseenter compat event
            // is NOT fired) and after a timeout (to allow for mouse compatibility
            // events to fire) we explicitly restart cycling
            this.pause();
            if (this.touchTimeout) clearTimeout(this.touchTimeout);
            this.touchTimeout = setTimeout(()=>this._maybeEnableCycle(), $dbacec9b9313e733$var$TOUCHEVENT_COMPAT_WAIT + this._config.interval);
        };
        const swipeConfig = {
            leftCallback: ()=>this._slide(this._directionToOrder($dbacec9b9313e733$var$DIRECTION_LEFT)),
            rightCallback: ()=>this._slide(this._directionToOrder($dbacec9b9313e733$var$DIRECTION_RIGHT)),
            endCallback: endCallBack
        };
        this._swipeHelper = new (0, $0bc25ea29b774e6d$export$2e2bcd8739ae039)(this._element, swipeConfig);
    }
    _keydown(event) {
        if (/input|textarea/i.test(event.target.tagName)) return;
        const direction = $dbacec9b9313e733$var$KEY_TO_DIRECTION[event.key];
        if (direction) {
            event.preventDefault();
            this._slide(this._directionToOrder(direction));
        }
    }
    _getItemIndex(element) {
        return this._getItems().indexOf(element);
    }
    _setActiveIndicatorElement(index) {
        if (!this._indicatorsElement) return;
        const activeIndicator = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_ACTIVE, this._indicatorsElement);
        activeIndicator.classList.remove($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
        activeIndicator.removeAttribute('aria-current');
        const newActiveIndicator = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne(`[data-bs-slide-to="${index}"]`, this._indicatorsElement);
        if (newActiveIndicator) {
            newActiveIndicator.classList.add($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
            newActiveIndicator.setAttribute('aria-current', 'true');
        }
    }
    _updateInterval() {
        const element = this._activeElement || this._getActive();
        if (!element) return;
        const elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
        this._config.interval = elementInterval || this._config.defaultInterval;
    }
    _slide(order, element = null) {
        if (this._isSliding) return;
        const activeElement = this._getActive();
        const isNext = order === $dbacec9b9313e733$var$ORDER_NEXT;
        const nextElement = element || (0, $624ac0747f128bc7$export$7bc25e2173fc3d1f)(this._getItems(), activeElement, isNext, this._config.wrap);
        if (nextElement === activeElement) return;
        const nextElementIndex = this._getItemIndex(nextElement);
        const triggerEvent = (eventName)=>{
            return (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, eventName, {
                relatedTarget: nextElement,
                direction: this._orderToDirection(order),
                from: this._getItemIndex(activeElement),
                to: nextElementIndex
            });
        };
        const slideEvent = triggerEvent($dbacec9b9313e733$var$EVENT_SLIDE);
        if (slideEvent.defaultPrevented) return;
        if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
        // TODO: change tests that use empty divs to avoid this check
        return;
        const isCycling = Boolean(this._interval);
        this.pause();
        this._isSliding = true;
        this._setActiveIndicatorElement(nextElementIndex);
        this._activeElement = nextElement;
        const directionalClassName = isNext ? $dbacec9b9313e733$var$CLASS_NAME_START : $dbacec9b9313e733$var$CLASS_NAME_END;
        const orderClassName = isNext ? $dbacec9b9313e733$var$CLASS_NAME_NEXT : $dbacec9b9313e733$var$CLASS_NAME_PREV;
        nextElement.classList.add(orderClassName);
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(nextElement);
        activeElement.classList.add(directionalClassName);
        nextElement.classList.add(directionalClassName);
        const completeCallBack = ()=>{
            nextElement.classList.remove(directionalClassName, orderClassName);
            nextElement.classList.add($dbacec9b9313e733$var$CLASS_NAME_ACTIVE);
            activeElement.classList.remove($dbacec9b9313e733$var$CLASS_NAME_ACTIVE, orderClassName, directionalClassName);
            this._isSliding = false;
            triggerEvent($dbacec9b9313e733$var$EVENT_SLID);
        };
        this._queueCallback(completeCallBack, activeElement, this._isAnimated());
        if (isCycling) this.cycle();
    }
    _isAnimated() {
        return this._element.classList.contains($dbacec9b9313e733$var$CLASS_NAME_SLIDE);
    }
    _getActive() {
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($dbacec9b9313e733$var$SELECTOR_ACTIVE_ITEM, this._element);
    }
    _getItems() {
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_ITEM, this._element);
    }
    _clearInterval() {
        if (this._interval) {
            clearInterval(this._interval);
            this._interval = null;
        }
    }
    _directionToOrder(direction) {
        if ((0, $624ac0747f128bc7$export$702d680b21cbd764)()) return direction === $dbacec9b9313e733$var$DIRECTION_LEFT ? $dbacec9b9313e733$var$ORDER_PREV : $dbacec9b9313e733$var$ORDER_NEXT;
        return direction === $dbacec9b9313e733$var$DIRECTION_LEFT ? $dbacec9b9313e733$var$ORDER_NEXT : $dbacec9b9313e733$var$ORDER_PREV;
    }
    _orderToDirection(order) {
        if ((0, $624ac0747f128bc7$export$702d680b21cbd764)()) return order === $dbacec9b9313e733$var$ORDER_PREV ? $dbacec9b9313e733$var$DIRECTION_LEFT : $dbacec9b9313e733$var$DIRECTION_RIGHT;
        return order === $dbacec9b9313e733$var$ORDER_PREV ? $dbacec9b9313e733$var$DIRECTION_RIGHT : $dbacec9b9313e733$var$DIRECTION_LEFT;
    }
    // Static
    static jQueryInterface(config) {
        return this.each(function() {
            const data = $dbacec9b9313e733$var$Carousel.getOrCreateInstance(this, config);
            if (typeof config === 'number') {
                data.to(config);
                return;
            }
            if (typeof config === 'string') {
                if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $dbacec9b9313e733$var$EVENT_CLICK_DATA_API, $dbacec9b9313e733$var$SELECTOR_DATA_SLIDE, function(event) {
    const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this);
    if (!target || !target.classList.contains($dbacec9b9313e733$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    const carousel = $dbacec9b9313e733$var$Carousel.getOrCreateInstance(target);
    const slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ((0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
(0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $dbacec9b9313e733$var$EVENT_LOAD_DATA_API, ()=>{
    const carousels = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($dbacec9b9313e733$var$SELECTOR_DATA_RIDE);
    for (const carousel of carousels)$dbacec9b9313e733$var$Carousel.getOrCreateInstance(carousel);
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($dbacec9b9313e733$var$Carousel);
var $dbacec9b9313e733$export$2e2bcd8739ae039 = $dbacec9b9313e733$var$Carousel;


/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 



/**
 * Constants
 */ const $d66ebc93fbedd854$var$NAME = 'collapse';
const $d66ebc93fbedd854$var$DATA_KEY = 'bs.collapse';
const $d66ebc93fbedd854$var$EVENT_KEY = `.${$d66ebc93fbedd854$var$DATA_KEY}`;
const $d66ebc93fbedd854$var$DATA_API_KEY = '.data-api';
const $d66ebc93fbedd854$var$EVENT_SHOW = `show${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_SHOWN = `shown${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_HIDE = `hide${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_HIDDEN = `hidden${$d66ebc93fbedd854$var$EVENT_KEY}`;
const $d66ebc93fbedd854$var$EVENT_CLICK_DATA_API = `click${$d66ebc93fbedd854$var$EVENT_KEY}${$d66ebc93fbedd854$var$DATA_API_KEY}`;
const $d66ebc93fbedd854$var$CLASS_NAME_SHOW = 'show';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE = 'collapse';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING = 'collapsing';
const $d66ebc93fbedd854$var$CLASS_NAME_COLLAPSED = 'collapsed';
const $d66ebc93fbedd854$var$CLASS_NAME_DEEPER_CHILDREN = `:scope .${$d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE} .${$d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE}`;
const $d66ebc93fbedd854$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
const $d66ebc93fbedd854$var$WIDTH = 'width';
const $d66ebc93fbedd854$var$HEIGHT = 'height';
const $d66ebc93fbedd854$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
const $d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
const $d66ebc93fbedd854$var$Default = {
    parent: null,
    toggle: true
};
const $d66ebc93fbedd854$var$DefaultType = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ class $d66ebc93fbedd854$var$Collapse extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._isTransitioning = false;
        this._triggerArray = [];
        const toggleList = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE);
        for (const elem of toggleList){
            const selector = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getSelectorFromElement(elem);
            const filterElement = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector).filter((foundElement)=>foundElement === this._element);
            if (selector !== null && filterElement.length) this._triggerArray.push(elem);
        }
        this._initializeChildren();
        if (!this._config.parent) this._addAriaAndCollapsedClass(this._triggerArray, this._isShown());
        if (this._config.toggle) this.toggle();
    }
    // Getters
    static get Default() {
        return $d66ebc93fbedd854$var$Default;
    }
    static get DefaultType() {
        return $d66ebc93fbedd854$var$DefaultType;
    }
    static get NAME() {
        return $d66ebc93fbedd854$var$NAME;
    }
    // Public
    toggle() {
        if (this._isShown()) this.hide();
        else this.show();
    }
    show() {
        if (this._isTransitioning || this._isShown()) return;
        let activeChildren = [];
        // find active children
        if (this._config.parent) activeChildren = this._getFirstLevelChildren($d66ebc93fbedd854$var$SELECTOR_ACTIVES).filter((element)=>element !== this._element).map((element)=>$d66ebc93fbedd854$var$Collapse.getOrCreateInstance(element, {
                toggle: false
            }));
        if (activeChildren.length && activeChildren[0]._isTransitioning) return;
        const startEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_SHOW);
        if (startEvent.defaultPrevented) return;
        for (const activeInstance of activeChildren)activeInstance.hide();
        const dimension = this._getDimension();
        this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE);
        this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
        this._element.style[dimension] = 0;
        this._addAriaAndCollapsedClass(this._triggerArray, true);
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE, $d66ebc93fbedd854$var$CLASS_NAME_SHOW);
            this._element.style[dimension] = '';
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_SHOWN);
        };
        const capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
        const scrollSize = `scroll${capitalizedDimension}`;
        this._queueCallback(complete, this._element, true);
        this._element.style[dimension] = `${this._element[scrollSize]}px`;
    }
    hide() {
        if (this._isTransitioning || !this._isShown()) return;
        const startEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_HIDE);
        if (startEvent.defaultPrevented) return;
        const dimension = this._getDimension();
        this._element.style[dimension] = `${this._element.getBoundingClientRect()[dimension]}px`;
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(this._element);
        this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
        this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE, $d66ebc93fbedd854$var$CLASS_NAME_SHOW);
        for (const trigger of this._triggerArray){
            const element = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(trigger);
            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                trigger
            ], false);
        }
        this._isTransitioning = true;
        const complete = ()=>{
            this._isTransitioning = false;
            this._element.classList.remove($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSING);
            this._element.classList.add($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSE);
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $d66ebc93fbedd854$var$EVENT_HIDDEN);
        };
        this._element.style[dimension] = '';
        this._queueCallback(complete, this._element, true);
    }
    // Private
    _isShown(element = this._element) {
        return element.classList.contains($d66ebc93fbedd854$var$CLASS_NAME_SHOW);
    }
    _configAfterMerge(config) {
        config.toggle = Boolean(config.toggle) // Coerce string values
        ;
        config.parent = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(config.parent);
        return config;
    }
    _getDimension() {
        return this._element.classList.contains($d66ebc93fbedd854$var$CLASS_NAME_HORIZONTAL) ? $d66ebc93fbedd854$var$WIDTH : $d66ebc93fbedd854$var$HEIGHT;
    }
    _initializeChildren() {
        if (!this._config.parent) return;
        const children = this._getFirstLevelChildren($d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE);
        for (const element of children){
            const selected = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(element);
            if (selected) this._addAriaAndCollapsedClass([
                element
            ], this._isShown(selected));
        }
    }
    _getFirstLevelChildren(selector) {
        const children = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($d66ebc93fbedd854$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
        // remove children if greater depth
        return (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector, this._config.parent).filter((element)=>!children.includes(element));
    }
    _addAriaAndCollapsedClass(triggerArray, isOpen) {
        if (!triggerArray.length) return;
        for (const element of triggerArray){
            element.classList.toggle($d66ebc93fbedd854$var$CLASS_NAME_COLLAPSED, !isOpen);
            element.setAttribute('aria-expanded', isOpen);
        }
    }
    // Static
    static jQueryInterface(config) {
        const _config = {};
        if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
        return this.each(function() {
            const data = $d66ebc93fbedd854$var$Collapse.getOrCreateInstance(this, _config);
            if (typeof config === 'string') {
                if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
                data[config]();
            }
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $d66ebc93fbedd854$var$EVENT_CLICK_DATA_API, $d66ebc93fbedd854$var$SELECTOR_DATA_TOGGLE, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    for (const element of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getMultipleElementsFromSelector(this))$d66ebc93fbedd854$var$Collapse.getOrCreateInstance(element, {
        toggle: false
    }).toggle();
});
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($d66ebc93fbedd854$var$Collapse);
var $d66ebc93fbedd854$export$2e2bcd8739ae039 = $d66ebc93fbedd854$var$Collapse;


/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $bf7f248d3696c78e$var$NAME = 'backdrop';
const $bf7f248d3696c78e$var$CLASS_NAME_FADE = 'fade';
const $bf7f248d3696c78e$var$CLASS_NAME_SHOW = 'show';
const $bf7f248d3696c78e$var$EVENT_MOUSEDOWN = `mousedown.bs.${$bf7f248d3696c78e$var$NAME}`;
const $bf7f248d3696c78e$var$Default = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    rootElement: 'body' // give the choice to place backdrop under different elements
};
const $bf7f248d3696c78e$var$DefaultType = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ class $bf7f248d3696c78e$var$Backdrop extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isAppended = false;
        this._element = null;
    }
    // Getters
    static get Default() {
        return $bf7f248d3696c78e$var$Default;
    }
    static get DefaultType() {
        return $bf7f248d3696c78e$var$DefaultType;
    }
    static get NAME() {
        return $bf7f248d3696c78e$var$NAME;
    }
    // Public
    show(callback) {
        if (!this._config.isVisible) {
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
            return;
        }
        this._append();
        const element = this._getElement();
        if (this._config.isAnimated) (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(element);
        element.classList.add($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
        });
    }
    hide(callback) {
        if (!this._config.isVisible) {
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
            return;
        }
        this._getElement().classList.remove($bf7f248d3696c78e$var$CLASS_NAME_SHOW);
        this._emulateAnimation(()=>{
            this.dispose();
            (0, $624ac0747f128bc7$export$51396ec711da548b)(callback);
        });
    }
    dispose() {
        if (!this._isAppended) return;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN);
        this._element.remove();
        this._isAppended = false;
    }
    // Private
    _getElement() {
        if (!this._element) {
            const backdrop = document.createElement('div');
            backdrop.className = this._config.className;
            if (this._config.isAnimated) backdrop.classList.add($bf7f248d3696c78e$var$CLASS_NAME_FADE);
            this._element = backdrop;
        }
        return this._element;
    }
    _configAfterMerge(config) {
        // use getElement() with the default "body" to get a fresh Element on each instantiation
        config.rootElement = (0, $624ac0747f128bc7$export$d16800b7e59a8051)(config.rootElement);
        return config;
    }
    _append() {
        if (this._isAppended) return;
        const element = this._getElement();
        this._config.rootElement.append(element);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(element, $bf7f248d3696c78e$var$EVENT_MOUSEDOWN, ()=>{
            (0, $624ac0747f128bc7$export$51396ec711da548b)(this._config.clickCallback);
        });
        this._isAppended = true;
    }
    _emulateAnimation(callback) {
        (0, $624ac0747f128bc7$export$d6cd5457cf4106ef)(callback, this._getElement(), this._config.isAnimated);
    }
}
var $bf7f248d3696c78e$export$2e2bcd8739ae039 = $bf7f248d3696c78e$var$Backdrop;


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


const $f4665fe10f4cce58$export$a6d6a0122b3f26ee = (component, method = 'hide')=>{
    const clickEvent = `click.dismiss${component.EVENT_KEY}`;
    const name = component.NAME;
    (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, clickEvent, `[data-bs-dismiss="${name}"]`, function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ((0, $624ac0747f128bc7$export$30e0dc115df457ed)(this)) return;
        const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this) || this.closest(`.${name}`);
        const instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};


/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $a4e4747603202ebf$var$NAME = 'focustrap';
const $a4e4747603202ebf$var$DATA_KEY = 'bs.focustrap';
const $a4e4747603202ebf$var$EVENT_KEY = `.${$a4e4747603202ebf$var$DATA_KEY}`;
const $a4e4747603202ebf$var$EVENT_FOCUSIN = `focusin${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB = `keydown.tab${$a4e4747603202ebf$var$EVENT_KEY}`;
const $a4e4747603202ebf$var$TAB_KEY = 'Tab';
const $a4e4747603202ebf$var$TAB_NAV_FORWARD = 'forward';
const $a4e4747603202ebf$var$TAB_NAV_BACKWARD = 'backward';
const $a4e4747603202ebf$var$Default = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
const $a4e4747603202ebf$var$DefaultType = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ class $a4e4747603202ebf$var$FocusTrap extends (0, $7beb0d0c06e1a235$export$2e2bcd8739ae039) {
    constructor(config){
        super();
        this._config = this._getConfig(config);
        this._isActive = false;
        this._lastTabNavDirection = null;
    }
    // Getters
    static get Default() {
        return $a4e4747603202ebf$var$Default;
    }
    static get DefaultType() {
        return $a4e4747603202ebf$var$DefaultType;
    }
    static get NAME() {
        return $a4e4747603202ebf$var$NAME;
    }
    // Public
    activate() {
        if (this._isActive) return;
        if (this._config.autofocus) this._config.trapElement.focus();
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(document, $a4e4747603202ebf$var$EVENT_KEY) // guard against infinite focus loop
        ;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $a4e4747603202ebf$var$EVENT_FOCUSIN, (event)=>this._handleFocusin(event));
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $a4e4747603202ebf$var$EVENT_KEYDOWN_TAB, (event)=>this._handleKeydown(event));
        this._isActive = true;
    }
    deactivate() {
        if (!this._isActive) return;
        this._isActive = false;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(document, $a4e4747603202ebf$var$EVENT_KEY);
    }
    // Private
    _handleFocusin(event) {
        const { trapElement: trapElement } = this._config;
        if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
        const elements = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).focusableChildren(trapElement);
        if (elements.length === 0) trapElement.focus();
        else if (this._lastTabNavDirection === $a4e4747603202ebf$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
        else elements[0].focus();
    }
    _handleKeydown(event) {
        if (event.key !== $a4e4747603202ebf$var$TAB_KEY) return;
        this._lastTabNavDirection = event.shiftKey ? $a4e4747603202ebf$var$TAB_NAV_BACKWARD : $a4e4747603202ebf$var$TAB_NAV_FORWARD;
    }
}
var $a4e4747603202ebf$export$2e2bcd8739ae039 = $a4e4747603202ebf$var$FocusTrap;



/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ 


/**
 * Constants
 */ const $6593efd307f387da$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
const $6593efd307f387da$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
const $6593efd307f387da$var$PROPERTY_PADDING = 'padding-right';
const $6593efd307f387da$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ class $6593efd307f387da$var$ScrollBarHelper {
    constructor(){
        this._element = document.body;
    }
    // Public
    getWidth() {
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
        const documentWidth = document.documentElement.clientWidth;
        return Math.abs(window.innerWidth - documentWidth);
    }
    hide() {
        const width = this.getWidth();
        this._disableOverFlow();
        // give padding to element to balance the hidden scrollbar width
        this._setElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING, (calculatedValue)=>calculatedValue + width);
        this._setElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN, (calculatedValue)=>calculatedValue - width);
    }
    reset() {
        this._resetElementAttributes(this._element, 'overflow');
        this._resetElementAttributes(this._element, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_FIXED_CONTENT, $6593efd307f387da$var$PROPERTY_PADDING);
        this._resetElementAttributes($6593efd307f387da$var$SELECTOR_STICKY_CONTENT, $6593efd307f387da$var$PROPERTY_MARGIN);
    }
    isOverflowing() {
        return this.getWidth() > 0;
    }
    // Private
    _disableOverFlow() {
        this._saveInitialAttribute(this._element, 'overflow');
        this._element.style.overflow = 'hidden';
    }
    _setElementAttributes(selector, styleProperty, callback) {
        const scrollbarWidth = this.getWidth();
        const manipulationCallBack = (element)=>{
            if (element !== this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
            this._saveInitialAttribute(element, styleProperty);
            const calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
            element.style.setProperty(styleProperty, `${callback(Number.parseFloat(calculatedValue))}px`);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _saveInitialAttribute(element, styleProperty) {
        const actualValue = element.style.getPropertyValue(styleProperty);
        if (actualValue) (0, $61e4c97070b47d88$export$2e2bcd8739ae039).setDataAttribute(element, styleProperty, actualValue);
    }
    _resetElementAttributes(selector, styleProperty) {
        const manipulationCallBack = (element)=>{
            const value = (0, $61e4c97070b47d88$export$2e2bcd8739ae039).getDataAttribute(element, styleProperty);
            // We only want to remove the property if the value is `null`; the value can also be zero
            if (value === null) {
                element.style.removeProperty(styleProperty);
                return;
            }
            (0, $61e4c97070b47d88$export$2e2bcd8739ae039).removeDataAttribute(element, styleProperty);
            element.style.setProperty(styleProperty, value);
        };
        this._applyManipulationCallback(selector, manipulationCallBack);
    }
    _applyManipulationCallback(selector, callBack) {
        if ((0, $624ac0747f128bc7$export$45a5e7f76e0caa8d)(selector)) {
            callBack(selector);
            return;
        }
        for (const sel of (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find(selector, this._element))callBack(sel);
    }
}
var $6593efd307f387da$export$2e2bcd8739ae039 = $6593efd307f387da$var$ScrollBarHelper;


/**
 * Constants
 */ const $8a7e64f151a1182a$var$NAME = 'modal';
const $8a7e64f151a1182a$var$DATA_KEY = 'bs.modal';
const $8a7e64f151a1182a$var$EVENT_KEY = `.${$8a7e64f151a1182a$var$DATA_KEY}`;
const $8a7e64f151a1182a$var$DATA_API_KEY = '.data-api';
const $8a7e64f151a1182a$var$ESCAPE_KEY = 'Escape';
const $8a7e64f151a1182a$var$EVENT_HIDE = `hide${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED = `hidePrevented${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_HIDDEN = `hidden${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOW = `show${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_SHOWN = `shown${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_RESIZE = `resize${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS = `click.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS = `mousedown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS = `keydown.dismiss${$8a7e64f151a1182a$var$EVENT_KEY}`;
const $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API = `click${$8a7e64f151a1182a$var$EVENT_KEY}${$8a7e64f151a1182a$var$DATA_API_KEY}`;
const $8a7e64f151a1182a$var$CLASS_NAME_OPEN = 'modal-open';
const $8a7e64f151a1182a$var$CLASS_NAME_FADE = 'fade';
const $8a7e64f151a1182a$var$CLASS_NAME_SHOW = 'show';
const $8a7e64f151a1182a$var$CLASS_NAME_STATIC = 'modal-static';
const $8a7e64f151a1182a$var$OPEN_SELECTOR = '.modal.show';
const $8a7e64f151a1182a$var$SELECTOR_DIALOG = '.modal-dialog';
const $8a7e64f151a1182a$var$SELECTOR_MODAL_BODY = '.modal-body';
const $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="modal"]';
const $8a7e64f151a1182a$var$Default = {
    backdrop: true,
    focus: true,
    keyboard: true
};
const $8a7e64f151a1182a$var$DefaultType = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ class $8a7e64f151a1182a$var$Modal extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._dialog = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$SELECTOR_DIALOG, this._element);
        this._backdrop = this._initializeBackDrop();
        this._focustrap = this._initializeFocusTrap();
        this._isShown = false;
        this._isTransitioning = false;
        this._scrollBar = new (0, $6593efd307f387da$export$2e2bcd8739ae039)();
        this._addEventListeners();
    }
    // Getters
    static get Default() {
        return $8a7e64f151a1182a$var$Default;
    }
    static get DefaultType() {
        return $8a7e64f151a1182a$var$DefaultType;
    }
    static get NAME() {
        return $8a7e64f151a1182a$var$NAME;
    }
    // Public
    toggle(relatedTarget) {
        return this._isShown ? this.hide() : this.show(relatedTarget);
    }
    show(relatedTarget) {
        if (this._isShown || this._isTransitioning) return;
        const showEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOW, {
            relatedTarget: relatedTarget
        });
        if (showEvent.defaultPrevented) return;
        this._isShown = true;
        this._isTransitioning = true;
        this._scrollBar.hide();
        document.body.classList.add($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
        this._adjustDialog();
        this._backdrop.show(()=>this._showElement(relatedTarget));
    }
    hide() {
        if (!this._isShown || this._isTransitioning) return;
        const hideEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE);
        if (hideEvent.defaultPrevented) return;
        this._isShown = false;
        this._isTransitioning = true;
        this._focustrap.deactivate();
        this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        this._queueCallback(()=>this._hideModal(), this._element, this._isAnimated());
    }
    dispose() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(window, $8a7e64f151a1182a$var$EVENT_KEY);
        (0, $1c297f733361d974$export$2e2bcd8739ae039).off(this._dialog, $8a7e64f151a1182a$var$EVENT_KEY);
        this._backdrop.dispose();
        this._focustrap.deactivate();
        super.dispose();
    }
    handleUpdate() {
        this._adjustDialog();
    }
    // Private
    _initializeBackDrop() {
        return new (0, $bf7f248d3696c78e$export$2e2bcd8739ae039)({
            isVisible: Boolean(this._config.backdrop),
            isAnimated: this._isAnimated()
        });
    }
    _initializeFocusTrap() {
        return new (0, $a4e4747603202ebf$export$2e2bcd8739ae039)({
            trapElement: this._element
        });
    }
    _showElement(relatedTarget) {
        // try to append dynamic modal
        if (!document.body.contains(this._element)) document.body.append(this._element);
        this._element.style.display = 'block';
        this._element.removeAttribute('aria-hidden');
        this._element.setAttribute('aria-modal', true);
        this._element.setAttribute('role', 'dialog');
        this._element.scrollTop = 0;
        const modalBody = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$SELECTOR_MODAL_BODY, this._dialog);
        if (modalBody) modalBody.scrollTop = 0;
        (0, $624ac0747f128bc7$export$b7a864e1eaef9de5)(this._element);
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_SHOW);
        const transitionComplete = ()=>{
            if (this._config.focus) this._focustrap.activate();
            this._isTransitioning = false;
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_SHOWN, {
                relatedTarget: relatedTarget
            });
        };
        this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
    }
    _addEventListeners() {
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $8a7e64f151a1182a$var$EVENT_KEYDOWN_DISMISS, (event)=>{
            if (event.key !== $8a7e64f151a1182a$var$ESCAPE_KEY) return;
            if (this._config.keyboard) {
                this.hide();
                return;
            }
            this._triggerBackdropTransition();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, $8a7e64f151a1182a$var$EVENT_RESIZE, ()=>{
            if (this._isShown && !this._isTransitioning) this._adjustDialog();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._element, $8a7e64f151a1182a$var$EVENT_MOUSEDOWN_DISMISS, (event)=>{
            // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
            (0, $1c297f733361d974$export$2e2bcd8739ae039).one(this._element, $8a7e64f151a1182a$var$EVENT_CLICK_DISMISS, (event2)=>{
                if (this._element !== event.target || this._element !== event2.target) return;
                if (this._config.backdrop === 'static') {
                    this._triggerBackdropTransition();
                    return;
                }
                if (this._config.backdrop) this.hide();
            });
        });
    }
    _hideModal() {
        this._element.style.display = 'none';
        this._element.setAttribute('aria-hidden', true);
        this._element.removeAttribute('aria-modal');
        this._element.removeAttribute('role');
        this._isTransitioning = false;
        this._backdrop.hide(()=>{
            document.body.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_OPEN);
            this._resetAdjustments();
            this._scrollBar.reset();
            (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDDEN);
        });
    }
    _isAnimated() {
        return this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_FADE);
    }
    _triggerBackdropTransition() {
        const hideEvent = (0, $1c297f733361d974$export$2e2bcd8739ae039).trigger(this._element, $8a7e64f151a1182a$var$EVENT_HIDE_PREVENTED);
        if (hideEvent.defaultPrevented) return;
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const initialOverflowY = this._element.style.overflowY;
        // return if the following background transition hasn't yet completed
        if (initialOverflowY === 'hidden' || this._element.classList.contains($8a7e64f151a1182a$var$CLASS_NAME_STATIC)) return;
        if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
        this._element.classList.add($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
        this._queueCallback(()=>{
            this._element.classList.remove($8a7e64f151a1182a$var$CLASS_NAME_STATIC);
            this._queueCallback(()=>{
                this._element.style.overflowY = initialOverflowY;
            }, this._dialog);
        }, this._dialog);
        this._element.focus();
    }
    /**
   * The following methods are used to handle overflowing modals
   */ _adjustDialog() {
        const isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
        const scrollbarWidth = this._scrollBar.getWidth();
        const isBodyOverflowing = scrollbarWidth > 0;
        if (isBodyOverflowing && !isModalOverflowing) {
            const property = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'paddingLeft' : 'paddingRight';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
        if (!isBodyOverflowing && isModalOverflowing) {
            const property = (0, $624ac0747f128bc7$export$702d680b21cbd764)() ? 'paddingRight' : 'paddingLeft';
            this._element.style[property] = `${scrollbarWidth}px`;
        }
    }
    _resetAdjustments() {
        this._element.style.paddingLeft = '';
        this._element.style.paddingRight = '';
    }
    // Static
    static jQueryInterface(config, relatedTarget) {
        return this.each(function() {
            const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(this, config);
            if (typeof config !== 'string') return;
            if (typeof data[config] === 'undefined') throw new TypeError(`No method named "${config}"`);
            data[config](relatedTarget);
        });
    }
}
/**
 * Data API implementation
 */ (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, $8a7e64f151a1182a$var$EVENT_CLICK_DATA_API, $8a7e64f151a1182a$var$SELECTOR_DATA_TOGGLE, function(event) {
    const target = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    (0, $1c297f733361d974$export$2e2bcd8739ae039).one(target, $8a7e64f151a1182a$var$EVENT_SHOW, (showEvent)=>{
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).one(target, $8a7e64f151a1182a$var$EVENT_HIDDEN, ()=>{
            if ((0, $624ac0747f128bc7$export$795910f5f15a9633)(this)) this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    const alreadyOpen = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne($8a7e64f151a1182a$var$OPEN_SELECTOR);
    if (alreadyOpen) $8a7e64f151a1182a$var$Modal.getInstance(alreadyOpen).hide();
    const data = $8a7e64f151a1182a$var$Modal.getOrCreateInstance(target);
    data.toggle(this);
});
(0, $f4665fe10f4cce58$export$a6d6a0122b3f26ee)($8a7e64f151a1182a$var$Modal);
/**
 * jQuery
 */ (0, $624ac0747f128bc7$export$6be86de4be20ff32)($8a7e64f151a1182a$var$Modal);
var $8a7e64f151a1182a$export$2e2bcd8739ae039 = $8a7e64f151a1182a$var$Modal;





const $fc21247cfefe7192$var$NAME = 'projectportfolio';
const $fc21247cfefe7192$var$SELECTOR_PORTFOLIO = '[data-project-portfolio]';
class $fc21247cfefe7192$var$ProjectPortfolio extends (0, $380170e9fa23ab96$export$2e2bcd8739ae039) {
    constructor(element, config){
        super(element, config);
        this._pageSize = parseInt(element.getAttribute('data-page-size') || '36', 10) || 36;
        this._visibleLimit = this._pageSize;
        this._items = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find('[data-project-item]', element).map((el)=>({
                el: el,
                categories: JSON.parse(el.getAttribute('data-project-categories') || '[]'),
                locations: JSON.parse(el.getAttribute('data-project-locations') || '[]')
            }));
        this._categoryBtns = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find('[data-filter-category-btn]', element);
        this._locationBtns = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find('[data-filter-location-btn]', element);
        this._locationWrapper = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-location-wrapper]', element);
        this._locationInput = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-location-input]', element);
        this._locationDropdown = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-location-dropdown]', element);
        this._locationEmpty = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-location-empty]', element);
        this._statusEl = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-status]', element);
        this._activeGroupEl = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-active-group]', element);
        this._activeChipsEl = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-active-chips]', element);
        this._clearBtns = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find('[data-filter-clear]', element);
        this._emptyStateEl = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-empty]', element);
        this._loadMoreContainer = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-load-more-container]', element);
        this._loadMoreBtn = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-load-more-btn]', element);
        this._loadAllBtn = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-load-all-btn]', element);
        this._activeCategories = new Set();
        this._activeLocations = new Set();
        this._bindEvents();
        this._restoreFromUrl();
        this._update();
    }
    static get NAME() {
        return $fc21247cfefe7192$var$NAME;
    }
    _bindEvents() {
        for (const btn of this._categoryBtns){
            const cat = btn.getAttribute('data-filter-category-btn');
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(btn, 'click', (e)=>{
                e.preventDefault();
                this._toggleSet(this._activeCategories, cat);
                this._syncUrl();
                this._update();
            });
        }
        for (const btn of this._locationBtns){
            const loc = btn.getAttribute('data-filter-location-btn');
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(btn, 'click', (e)=>{
                e.preventDefault();
                this._toggleSet(this._activeLocations, loc);
                if (this._locationInput && this._locationInput.value) {
                    this._locationInput.value = '';
                    this._filterLocationSearch('');
                }
                this._syncUrl();
                this._update();
            });
        }
        if (this._locationInput && this._locationWrapper) {
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._locationInput, 'focus', ()=>{
                this._openLocationDropdown();
            });
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._locationInput, 'click', ()=>{
                this._openLocationDropdown();
            });
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._locationInput, 'input', ()=>{
                this._openLocationDropdown();
                this._filterLocationSearch(this._locationInput.value);
            });
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._locationInput, 'keydown', (e)=>{
                if (e.key === 'Escape') {
                    this._closeLocationDropdown();
                    this._locationInput.blur();
                }
            });
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._locationWrapper, 'click', (e)=>{
                e.stopPropagation();
            });
            (0, $1c297f733361d974$export$2e2bcd8739ae039).on(document, 'click', ()=>{
                this._closeLocationDropdown();
            });
        }
        for (const clearBtn of this._clearBtns)(0, $1c297f733361d974$export$2e2bcd8739ae039).on(clearBtn, 'click', (e)=>{
            e.preventDefault();
            this._activeCategories.clear();
            this._activeLocations.clear();
            if (this._locationInput) {
                this._locationInput.value = '';
                this._filterLocationSearch('');
            }
            this._syncUrl();
            this._update();
        });
        if (this._loadMoreBtn) (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._loadMoreBtn, 'click', (e)=>{
            e.preventDefault();
            this._visibleLimit += this._pageSize;
            this._update();
        });
        if (this._loadAllBtn) (0, $1c297f733361d974$export$2e2bcd8739ae039).on(this._loadAllBtn, 'click', (e)=>{
            e.preventDefault();
            this._visibleLimit = this._items.length;
            this._update();
        });
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(window, 'popstate', ()=>{
            this._restoreFromUrl();
            this._update();
        });
    }
    _openLocationDropdown() {
        if (!this._locationWrapper || !this._locationInput) return;
        this._locationWrapper.classList.add('is-open');
        this._locationInput.setAttribute('aria-expanded', 'true');
    }
    _closeLocationDropdown() {
        if (!this._locationWrapper || !this._locationInput) return;
        this._locationWrapper.classList.remove('is-open');
        this._locationInput.setAttribute('aria-expanded', 'false');
    }
    _toggleSet(set, value) {
        if (set.has(value)) set.delete(value);
        else set.add(value);
    }
    _restoreFromUrl() {
        this._activeCategories.clear();
        this._activeLocations.clear();
        const params = new URLSearchParams(window.location.search);
        const validCategories = new Map(this._categoryBtns.map((b)=>{
            const name = b.getAttribute('data-filter-category-btn');
            return [
                name.toLowerCase(),
                name
            ];
        }));
        const validLocations = new Map(this._locationBtns.map((b)=>{
            const name = b.getAttribute('data-filter-location-btn');
            return [
                name.toLowerCase(),
                name
            ];
        }));
        for (const rawCat of params.getAll('category'))for (const part of rawCat.split(',')){
            const canonical = validCategories.get(part.trim().toLowerCase());
            if (canonical) this._activeCategories.add(canonical);
        }
        for (const rawLoc of params.getAll('location'))for (const part of rawLoc.split(',')){
            const canonical = validLocations.get(part.trim().toLowerCase());
            if (canonical) this._activeLocations.add(canonical);
        }
    }
    _syncUrl() {
        const url = new URL(window.location.href);
        url.searchParams.delete('category');
        url.searchParams.delete('location');
        for (const cat of this._activeCategories)url.searchParams.append('category', cat);
        for (const loc of this._activeLocations)url.searchParams.append('location', loc);
        window.history.replaceState({}, '', url.toString());
    }
    _matchesCategories(item) {
        if (this._activeCategories.size === 0) return true;
        return item.categories.some((c)=>this._activeCategories.has(c));
    }
    _matchesLocations(item) {
        if (this._activeLocations.size === 0) return true;
        return item.locations.some((l)=>this._activeLocations.has(l));
    }
    _update() {
        const hasFilters = this._activeCategories.size > 0 || this._activeLocations.size > 0;
        // 1. Filter items & apply progressive batching when no filters are active
        let matchedCount = 0;
        let shownCount = 0;
        for (const item of this._items){
            const matches = this._matchesCategories(item) && this._matchesLocations(item);
            if (!matches) {
                item.el.classList.add('project-card--filtered-out');
                item.el.classList.remove('project-card--paged');
                continue;
            }
            matchedCount++;
            item.el.classList.remove('project-card--filtered-out');
            if (!hasFilters && matchedCount > this._visibleLimit) item.el.classList.add('project-card--paged');
            else {
                item.el.classList.remove('project-card--paged');
                shownCount++;
            }
        }
        // 2. Cross-update Category counts (filtered by currently active Locations)
        for (const btn of this._categoryBtns){
            const cat = btn.getAttribute('data-filter-category-btn');
            const isSelected = this._activeCategories.has(cat);
            let availableCount = 0;
            for (const item of this._items)if (this._matchesLocations(item) && item.categories.includes(cat)) availableCount++;
            btn.classList.toggle('active', isSelected);
            btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            const countSpan = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-count]', btn);
            if (countSpan) countSpan.textContent = `${availableCount}`;
            if (availableCount === 0 && !isSelected) btn.classList.add('d-none');
            else btn.classList.remove('d-none');
        }
        // 3. Cross-update Location counts (filtered by currently active Categories)
        for (const btn of this._locationBtns){
            const loc = btn.getAttribute('data-filter-location-btn');
            const isSelected = this._activeLocations.has(loc);
            let availableCount = 0;
            for (const item of this._items)if (this._matchesCategories(item) && item.locations.includes(loc)) availableCount++;
            btn.classList.toggle('active', isSelected);
            btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
            const countSpan = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).findOne('[data-filter-count]', btn);
            if (countSpan) countSpan.textContent = `${availableCount}`;
            btn.setAttribute('data-available-count', `${availableCount}`);
            if (availableCount === 0 && !isSelected) btn.classList.add('d-none');
            else btn.classList.remove('d-none');
        }
        // Re-apply text search inside the location dropdown if user has typed something
        if (this._locationInput) this._filterLocationSearch(this._locationInput.value);
        // 4. Update status text & active filter chips
        const total = this._items.length;
        if (this._statusEl) {
            if (hasFilters) this._statusEl.textContent = `Showing ${matchedCount} of ${total} projects`;
            else this._statusEl.textContent = `Showing ${shownCount} of ${total} projects`;
        }
        if (this._activeGroupEl && this._activeChipsEl) {
            this._activeChipsEl.innerHTML = '';
            if (hasFilters) {
                this._activeGroupEl.classList.remove('d-none');
                for (const cat of this._activeCategories)this._activeChipsEl.appendChild(this._createActiveChip(cat, 'Category', ()=>{
                    this._activeCategories.delete(cat);
                    this._syncUrl();
                    this._update();
                }));
                for (const loc of this._activeLocations)this._activeChipsEl.appendChild(this._createActiveChip(loc, 'Location', ()=>{
                    this._activeLocations.delete(loc);
                    this._syncUrl();
                    this._update();
                }));
            } else this._activeGroupEl.classList.add('d-none');
        }
        // 5. Empty state
        if (this._emptyStateEl) this._emptyStateEl.classList.toggle('d-none', matchedCount > 0);
        // 6. Load More bar visibility
        if (this._loadMoreContainer) {
            const hasMoreUnfiltered = !hasFilters && shownCount < matchedCount;
            this._loadMoreContainer.classList.toggle('d-none', !hasMoreUnfiltered);
            if (this._loadMoreBtn) {
                const remaining = matchedCount - shownCount;
                const nextBatch = Math.min(this._pageSize, remaining);
                this._loadMoreBtn.textContent = `Load ${nextBatch} More Projects`;
            }
        }
    }
    _createActiveChip(label, typeLabel, onRemove) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'project-filter--active-chip';
        btn.setAttribute('aria-label', `Remove ${typeLabel.toLowerCase()} filter: ${label}`);
        btn.innerHTML = `<span class="project-filter--chip-label">${label}</span><span class="project-filter--chip-remove" aria-hidden="true">&times;</span>`;
        (0, $1c297f733361d974$export$2e2bcd8739ae039).on(btn, 'click', (e)=>{
            e.preventDefault();
            onRemove();
        });
        return btn;
    }
    _filterLocationSearch(query) {
        const normalized = (query || '').trim().toLowerCase();
        let visibleCount = 0;
        for (const btn of this._locationBtns){
            const loc = (btn.getAttribute('data-filter-location-btn') || '').toLowerCase();
            const availableCount = parseInt(btn.getAttribute('data-available-count') || '1', 10);
            const isSelected = this._activeLocations.has(btn.getAttribute('data-filter-location-btn'));
            if (availableCount === 0 && !isSelected) {
                btn.classList.add('d-none');
                continue;
            }
            if (!normalized || loc.includes(normalized)) {
                btn.classList.remove('d-none');
                visibleCount++;
            } else btn.classList.add('d-none');
        }
        if (this._locationEmpty) this._locationEmpty.classList.toggle('d-none', visibleCount > 0);
    }
}
function $fc21247cfefe7192$var$initPortfolios() {
    const portfolios = (0, $56a58c95834dffd7$export$2e2bcd8739ae039).find($fc21247cfefe7192$var$SELECTOR_PORTFOLIO);
    for (const portfolio of portfolios)$fc21247cfefe7192$var$ProjectPortfolio.getOrCreateInstance(portfolio);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', $fc21247cfefe7192$var$initPortfolios);
else $fc21247cfefe7192$var$initPortfolios();
var $fc21247cfefe7192$export$2e2bcd8739ae039 = $fc21247cfefe7192$var$ProjectPortfolio;


function $a36f5593787d557d$var$preloadSlideAndNeighbors(carouselEl, index) {
    if (!carouselEl) return;
    const items = carouselEl.querySelectorAll('.carousel-item');
    const total = items.length;
    if (total === 0) return;
    const indices = [
        index,
        (index - 1 + total) % total,
        (index + 1) % total
    ];
    for (const idx of indices){
        const img = items[idx]?.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
    }
}
document.addEventListener('show.bs.modal', (e)=>{
    const modal = e.target;
    if (!modal || !modal.classList.contains('galleryElement--modal')) return;
    const carouselEl = modal.querySelector('.carousel');
    if (!carouselEl) return;
    const items = Array.from(carouselEl.querySelectorAll('.carousel-item'));
    const activeIdx = Math.max(0, items.findIndex((el)=>el.classList.contains('active')));
    $a36f5593787d557d$var$preloadSlideAndNeighbors(carouselEl, activeIdx);
});
document.addEventListener('slide.bs.carousel', (e)=>{
    const carouselEl = e.target;
    if (!carouselEl || !carouselEl.closest('.galleryElement--modal')) return;
    if (typeof e.to === 'number') $a36f5593787d557d$var$preloadSlideAndNeighbors(carouselEl, e.to);
});
document.addEventListener('keydown', (e)=>{
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    const openModal = document.querySelector('.galleryElement--modal.show');
    if (!openModal) return;
    const carouselEl = openModal.querySelector('.carousel');
    if (!carouselEl) return;
    const carousel = (0, $dbacec9b9313e733$export$2e2bcd8739ae039).getOrCreateInstance(carouselEl);
    e.preventDefault();
    if (e.key === 'ArrowLeft') carousel.prev();
    else carousel.next();
});
var $a36f5593787d557d$export$2e2bcd8739ae039 = {
    Carousel: //    Alert,
    //    Button,
    $dbacec9b9313e733$export$2e2bcd8739ae039,
    Collapse: $d66ebc93fbedd854$export$2e2bcd8739ae039,
    Modal: //    Dropdown,
    $8a7e64f151a1182a$export$2e2bcd8739ae039,
    Filtering: //    Offcanvas,
    //    Popover,
    //    ScrollSpy,
    //    Tab,
    //    Toast,
    //    Tooltip,
    $fc21247cfefe7192$export$2e2bcd8739ae039
};

})();
//# sourceMappingURL=index.js.map
